import type { CalendarsTranslationMessages } from './calendarsTranslationMessages';

const personalCalendarsLanguageEnglish: CalendarsTranslationMessages['me/calendars'] = {
  name: 'Calendars',
  fields: {
    id: 'ID',
    description: 'Description',
    title: 'Title',
    mode: 'Mode',
  },
  operations: {
    create: 'Create Calendar',
    delete: 'Delete Calendar',
    edit: 'Edit Calendar',
  },
};

const personalCalendarEventsLanguageEnglish: CalendarsTranslationMessages['me/calendar_events'] = {
  name: 'Personal Events',
  fields: {
    all_day: 'All Day',
    calendar: 'Calendar',
    description: 'Description',
    dtend: 'End',
    dtstart: 'Start',
    id: 'ID',
    metadata: 'Meta',
    title: 'Title',
    tzid: 'Time Zone',
    rrule: {
      count: 'Number of occurrences',
      freq: 'Frequency',
      until: 'End date of occurrences',
      bymonth: 'Occurrences in months',
      bymonthday: 'Occurrences on days of the month',
      byweekday: 'Occurrences on days of the week',
      interval: 'Interval',
    },
    enableRrule: 'Enable recurrence',
    recurrenceType: 'Recurrence type',
  },
  operations: {
    create: 'Create Event',
    delete: 'Delete Event',
    edit: 'Edit Event',
    sections: {
      details: 'Event details',
      advancedSettings: 'Advanced',
    },
  },
  frequencies: {
    daily: 'Every day',
    weekly: 'Every week',
    monthly: 'Every month',
    yearly: 'Every year',
  },
  weekdays: {
    mo: 'Monday',
    tu: 'Tuesday',
    we: 'Wednesday',
    th: 'Thursday',
    fr: 'Friday',
    sa: 'Saturday',
    su: 'Sunday',
  },
  months: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  },
  recurrenceTypes: {
    counted: 'Number of occurrences',
    until: 'Until a date',
  },
};

const domainCalendarsLanguageEnglish: CalendarsTranslationMessages['calendars'] = {
  ...personalCalendarsLanguageEnglish,
  fields: {
    ...personalCalendarsLanguageEnglish.fields,
    owner: 'Owner',
    labels: { id: 'Labels', name: 'Labels' },
  },
  operations: {
    ...personalCalendarsLanguageEnglish.operations,
    sections: {
      details: 'Calendar Details',
    },
  },
};

const domainCalendarEventsLanguageEnglish: CalendarsTranslationMessages['calendar_events'] = {
  ...personalCalendarEventsLanguageEnglish,
  name: 'Events',
};

export const calendarsLanguageEnglish: CalendarsTranslationMessages = {
  'me/calendars': personalCalendarsLanguageEnglish,
  'me/calendar_events': personalCalendarEventsLanguageEnglish,
  calendars: domainCalendarsLanguageEnglish,
  calendar_events: domainCalendarEventsLanguageEnglish,
};
